import React, { useState, useEffect } from "react";
import uuid from "react-uuid";

import NavigationItem from "../../model/NavigationItem";

import {
    StyledMenuItem,
    StyledNavLink,
} from "../../styles/components/NavBarStyles";
import { SelectArrowDownIcon, SelectArrowUpIcon } from "../Icons";
import MenuSubItem from "./MenuSubItem";

interface IActiveStyle {
    color: string;
}

interface IMenuItem {
    open: boolean;
    setOpen: (value: boolean) => void;
    forceUpdate: boolean;
    setForceUpdate: (value: boolean) => void;
    activeStyle: IActiveStyle;
    menuItem: (title: string) => React.ReactNode;
    title: string;
    icon: React.ReactNode;
    navItems: NavigationItem[];
}

const MenuItem = ({
    open,
    setOpen,
    forceUpdate,
    setForceUpdate,
    activeStyle,
    menuItem,
    title,
    icon,
    navItems,
}: IMenuItem) => {
    const [openMenuItens, setOpenMenuItens] = useState(true);

    useEffect(() => {
        if (!forceUpdate) {
            setForceUpdate(true);
        }
    }, [forceUpdate, setForceUpdate]);

    const handleMenu = () => {
        setOpen(true);
        if (open) setOpenMenuItens(!openMenuItens);
        else setOpenMenuItens(true);
    };

    const selectArrow = openMenuItens ? (
        <SelectArrowUpIcon />
    ) : (
        <SelectArrowDownIcon />
    );

    return (
        <>
            <StyledNavLink key={uuid()}>
                <StyledMenuItem onClick={handleMenu} onMouseEnter={() => {}}>
                    {icon}
                    {menuItem(title)}
                    {!open ? null : selectArrow}
                </StyledMenuItem>
            </StyledNavLink>
            {openMenuItens && open && (
                <MenuSubItem
                    activeStyle={activeStyle}
                    menuItem={menuItem}
                    navItems={navItems}
                />
            )}
        </>
    );
};

export default MenuItem;
